(() => {
  const init = (root) => {
    if (!root || root.dataset.hbeReady) return;
    root.dataset.hbeReady = 'true';
    const content = root.querySelector('.article__content');
    const headings = content ? [...content.querySelectorAll('h2,h3')].filter(h => h.textContent.trim() && !h.closest('form, [data-no-toc]')) : [];
    const topLevel = headings.some(h => h.tagName === 'H2') ? headings.filter(h => h.tagName === 'H2') : headings;
    topLevel.forEach((heading, i) => {
      if (heading.id) return;
      let id = `article-${root.dataset.sectionId}-${i + 1}`;
      while (document.getElementById(id)) id += '-section';
      heading.id = id;
    });
    const tocHeadings = root.classList.contains('hbe--journal') ? headings : topLevel;
    tocHeadings.forEach((heading, i) => {
      if (heading.id) return;
      let id = `article-${root.dataset.sectionId}-subsection-${i + 1}`;
      while (document.getElementById(id)) id += '-section';
      heading.id = id;
    });
    root.querySelectorAll('[data-hbe-toc-list]').forEach(list => {
      const items = [];
      let parent = null;
      let nested = null;
      tocHeadings.forEach(heading => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        li.append(link);
        if (heading.tagName === 'H3' && parent) {
          if (!nested) {
            nested = document.createElement('ol');
            parent.append(nested);
          }
          nested.append(li);
        } else {
          items.push(li);
          parent = heading.tagName === 'H2' ? li : null;
          nested = null;
        }
      });
      list.replaceChildren(...items);
    });
    if (tocHeadings.length > 1) root.querySelectorAll('[data-hbe-toc]').forEach(el => { el.hidden = false; });
    const setActive = (id) => root.querySelectorAll('[data-hbe-toc-list] a').forEach(link => {
      if (link.getAttribute('href') === `#${id}`) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const visible = entries.filter(e => e.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      }, { rootMargin: '-12% 0px -65% 0px' });
      tocHeadings.forEach(h => observer.observe(h));
    }
    root.querySelector('[data-hbe-copy]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const url = document.querySelector('link[rel="canonical"]')?.href || location.href.split('?')[0];
      try {
        await navigator.clipboard.writeText(url);
        root.querySelector('[data-hbe-copy-status]').textContent = button.dataset.copied;
        button.textContent = button.dataset.copied;
      } catch {
        const field = document.createElement('input');
        field.readOnly = true;
        field.value = url;
        button.after(field);
        field.focus();
        field.select();
      }
    });
    const hideGuide = () => {
      const widget = document.getElementById('ecomsend-widget');
      if (widget) { widget.inert = true; widget.setAttribute('aria-hidden', 'true'); }
      document.querySelectorAll('.react-responsive-modal-root:has(.ecomsend__Modal__Container)').forEach(portal => {
        portal.inert = true;
        portal.setAttribute('aria-hidden', 'true');
        const close = portal.querySelector('.ecomsend__Modal__CloseButton');
        if (close && !close.dataset.hbeDismissed) {
          close.dataset.hbeDismissed = 'true';
          close.click();
        }
      });
    };
    hideGuide();
    new MutationObserver(hideGuide).observe(document.body, { childList: true, subtree: true });
    if (!root.hasAttribute('data-hbe-r290')) return;
    const track = (event, extra = {}) => {
      if (location.search.includes('view=')) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, article_handle: 'ilmalampopumppujen-uusi-aikakausi', ...extra });
    };
    const quote = root.querySelector('#r290-tarjous');
    const form = quote?.querySelector('form');
    const lead = quote?.querySelector('hesatek-compact-lead');
    root.querySelectorAll('[data-hbe-cta]').forEach(link => link.addEventListener('click', () => {
      if (lead) lead.dataset.articleCta = link.dataset.hbeCta;
      track('article_quote_cta_click', { cta_position: link.dataset.hbeCta });
      quote?.setAttribute('tabindex', '-1');
      requestAnimationFrame(() => quote?.focus({ preventScroll: true }));
    }));
    let started = false;
    form?.addEventListener('input', () => {
      if (started) return;
      started = true;
      track('article_quote_form_start', { cta_position: lead?.dataset.articleCta || 'form' });
    });
    if ('IntersectionObserver' in window) {
      const seen = new Set();
      const views = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const position = entry.target.dataset.hbeCta;
        if (seen.has(position)) return;
        seen.add(position);
        track('article_quote_cta_view', { cta_position: position });
      }), { threshold: .5 });
      root.querySelectorAll('[data-hbe-cta]').forEach(el => views.observe(el));
    }
    lead?.addEventListener('hesatek:lead-received', () => {
      track('article_quote_received', { cta_position: lead.dataset.articleCta || 'form' });
    });

  };
  const boot = () => document.querySelectorAll('[data-hbe]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
